export const MIXPANEL_EVENTS_PART = {
  PART_OPEN: 'part_open',
  // Part Create
  PART_CREATE_FROM_UPLOAD_REFERENCE: 'part_create_from_upload_reference',
  PART_CREATE_FROM_UPLOAD_SCAN: 'part_create_from_upload_scan',
  PART_CREATE_FROM_NEW_SCAN: 'part_create_from_new_scan'
}
